import { createRouter, createWebHistory } from 'vue-router';
import Store from '@/store/store';

import Login from '@/views/login/LoginView';
import Dashboard from '@/views/dashboard/DashboardView';
// import MyFx from '@/views/myFx/MyFx'
import MyFxPreview from '@/views/myFx/MyFxPreview';
import MyFxForm from '@/views/myFx/MyFxForm';
import PitStatement from '@/views/pit/PitStatement';
import MifidQuestionnaire from '@/views/mifid/MifidQuestionnaire';
// import NewAccountForm from '@/views/newAccount/NewAccountForm';
import Training from '@/views/training/TrainingList';
// statusPage
import StatusPage from '@/views/statusPage/StatusPage';
//
import LearningPage from '@/views/Learning/LearningView';
import LearnigVideosPage from '@/views/Learning/LearningVideos';
import LearningTest from '@/views/Learning/LearningTest';
import LearningTestResult from '@/views/Learning/LearningTestResult';

async function checkSession(isMtUser, useAutoLogin = false) {
	Store.commit('setGlobalErrorMessage', '');
	Store.commit('setGlobalSuccessMessage', '');

	// // Jeśli użytkownik nie istnieje, pobierz go asynchronicznie
	await Store.dispatch('fetchCurrentUser');

	const updatedUser = Store.getters['getCurrentUser'];

	if (updatedUser) {
		if (useAutoLogin) {
			await Store.dispatch('autoLogIn');
		}
		if (
			isMtUser &&
			(!updatedUser.mt || (updatedUser.mt && updatedUser.sso))
		) {
			return false;
		} else {
			return true;
		}
	} else {
		return false;
	}
}

function isVideoScriptExist(url) {
	if (!url) url = 'https://www.youtube.com/iframe_api';
	var scripts = document.getElementsByTagName('script');
	for (var i = scripts.length; i--; ) {
		if (scripts[i].src == url) return true;
	}
	return false;
}

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes: [
		{
			path: '/:catchAll(.*)',
			name: '',
			component: Login,
			meta: { title: 'Login' },
			async beforeEnter(to, from, next) {
				if (await checkSession()) {
					next('/Dashboard');
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/Login',
			name: 'login',
			component: Login,
			meta: { title: 'Login' },
			async beforeEnter(to, from, next) {
				const updatedUser = Store.getters['getCurrentUser'];

				if (!updatedUser && (!to.query.s || !(await checkSession()))) {
					next();
				} else {
					next('/Dashboard');
				}
			},
		},
		{
			path: '/Dashboard',
			name: 'dashboard',
			exact: true,
			component: Dashboard,
			meta: { title: 'Pulpit' },
			async beforeEnter(to, from, next) {
				if (await checkSession(false, true)) {
					next();
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/MyFx',
			name: 'myFxPreview',
			component: MyFxPreview,
			meta: { title: 'Moje dane' },
			async beforeEnter(to, from, next) {
				if (await checkSession(true)) {
					next();
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/MyFxEdit',
			name: 'myFxEdit',
			component: MyFxForm,
			meta: { title: 'Moje dane' },
			async beforeEnter(to, from, next) {
				if (await checkSession(true)) {
					next();
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/Pit',
			name: 'pit',
			component: PitStatement,
			meta: { title: 'PIT' },
			async beforeEnter(to, from, next) {
				if (await checkSession()) {
					next();
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/Mifid',
			name: 'mifid',
			component: MifidQuestionnaire,
			meta: { title: 'Ankieta MIFID' },
			async beforeEnter(to, from, next) {
				if (await checkSession()) {
					next();
				} else {
					next('/Login');
				}
			},
		},

		{
			path: '/Training',
			name: 'training',
			component: Training,
			meta: { title: 'Szkolenia' },
			async beforeEnter(to, from, next) {
				if (await checkSession()) {
					next();
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/StatusPage',
			name: 'StatusPage',
			exact: false,
			component: StatusPage,
			meta: { title: 'Status przelewu' },
			async beforeEnter(to, from, next) {
				if (await checkSession()) {
					next();
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/eLearning',
			name: 'eLearning',
			exact: true,
			component: LearningPage,
			meta: { title: 'eLearning' },
			async beforeEnter(to, from, next) {
				if (await checkSession()) {
					next();
				} else {
					next('/Login');
				}
			},
		},
		{
			path: '/eLearningCourses',
			name: 'eLearningVideos',
			exact: true,
			component: LearnigVideosPage,
			meta: { title: 'eLearning' },
			async beforeEnter(to, from, next) {
				if (
					(await checkSession()) &&
					Store.getters.getCourses &&
					Store.getters.getSelectedVideo &&
					isVideoScriptExist('https://www.youtube.com/iframe_api') &&
					!localStorage.getItem('videoSection')
				) {
					next();
				} else {
					Store.commit('setCookieYTModal', true);
					next('/eLearning');
				}
			},
		},
		{
			path: '/eLearningTest',
			name: 'eLearningTest',
			exact: true,
			component: LearningTest,
			meta: { title: 'eLearning' },
			async beforeEnter(to, from, next) {
				if ((await checkSession()) && Store.getters.getIsTestAllow) {
					next();
				} else {
					next('/eLearning');
				}
			},
		},
		{
			path: '/eLearningResult',
			name: 'eLearningTestResult',
			exact: true,
			component: LearningTestResult,
			meta: { title: 'eLearning' },
			async beforeEnter(to, from, next) {
				if ((await checkSession()) && Store.getters.getTestResult) {
					next();
				} else {
					next('/eLearning');
				}
			},
		},
	],
	scrollBehavior() {
		return { top: 0 };
	},
});

export default router;
